import React, { useEffect, useState } from "react";
import loaderGif from "../../../../../../assets/images/loader.gif";
import { Tooltip } from "react-tooltip";
import "../Dsp.css";

const DspList = ({
  tableData,
  getDsp,
  updateStatus,
  loader,
  sortingColumn,
  sortingOrder,
  onSort,
  search,
}) => {
  const dspListData = (id) => {
    getDsp(id);
  };

  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="srno">Sr. No.</th>

              <th className="partner" onClick={() => onSort("dsp_key")}>
                Key{" "}
                {sortingColumn === "dsp_key" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="deal-name" style={{ width: "900px" }} onClick={() => onSort("name")}>
                Name{" "}
                {sortingColumn === "name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="status" onClick={() => onSort("status")}>
                Status{" "}
                {sortingColumn === "status" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="action">Action</th>
            </tr>
          </thead>

          {!loader ? (
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData?.map((item, i) => (
                  <React.Fragment key={i}>
                    <tr>
                      <td>{i + 1}</td>
                      <td className="action">{item?.dsp_key}</td>
                      <td style={{ whiteSpace: "pre-line" }}>
                        {item?.name?.trim() || "—"}
                      </td>
                      <td className="text-center status">
                        <label className="custom-switch">
                          <input
                            type="checkbox"
                            checked={item?.status === 1}
                            onClick={() =>
                              updateStatus(item.id, item.status === 1 ? 0 : 1)
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                      <td className="text-center status">
                        <div className="table-icons">
                          <i
                            className="fa-regular fa-pen-to-square green"
                            onClick={() => dspListData(item?.id)}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          ) : (
            <div className={`loader ${loader ? "show" : ""}`}>
              <label>
                <img src={loaderGif} alt="Loading..." />
              </label>
            </div>
          )}
        </table>
      </div>

      <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />
    </>
  );
};

export default DspList;
